import { render, staticRenderFns } from "./faultManage.vue?vue&type=template&id=481c7166&scoped=true&"
import script from "./faultManage.vue?vue&type=script&lang=js&"
export * from "./faultManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c7166",
  null
  
)

export default component.exports